import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { NavLink, useLocation } from "react-router-dom";
import axios from "axios";
import BASE_URL from "../Config";
import Swal from "sweetalert2";

// Function to fetch data from the API
const getSpotRegistrationData = async (payload) => {
  try {
    const response = await fetch(`${BASE_URL}/getDelegateDataforReprint`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};

const BadgeAssigned = () => {
  const userRole = parseInt(sessionStorage.getItem("userRole"), 10);

  const navigate = useNavigate();
  const location = useLocation();
  const [data, setData] = useState([]);
  const [pagination, setPagination] = useState({
    totalRecords: 0,
    currentPage: 1,
    totalPages: 1,
    pageSize: 25,
  });
  const [search, setSearch] = useState("");
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const tabs =
    userRole === 3
      ? [
          {
            label: "Registration Request",
            path: "/review-list-of-spot-registration",
          },
          { label: "Badge Print/Assign", path: "/express-entry/badge-print" },
          { label: "Badge Assigned", path: "/express-entry/badge-assigned" },
          { label: "Check In Status", path: "/express-entry/check-in" },
        ]
      : userRole === 5
      ? [
          { label: "Badge Print/Assign", path: "/express-entry/badge-print" },
          { label: "Badge Assigned", path: "/express-entry/badge-assigned" },
          { label: "Check In Status", path: "/express-entry/check-in" },
        ]
      : [
          {
            label: "Registration Request",
            path: "/review-list-of-spot-registration",
          },
          { label: "Badge Print/Assign", path: "/express-entry/badge-print" },
          { label: "Badge Assigned", path: "/express-entry/badge-assigned" },
          {
            label: "Badge Re-Issue",
            path: "/express-entry/badge-reassigned",
          },
          { label: "Check In Status", path: "/express-entry/check-in" },
        ];

  // Fetch data from API
  const fetchData = async () => {
    const payload = {
      page: pagination.currentPage,
      limit: pagination.pageSize,
      sortBy: "created_at",
      sortOrder: "desc",
      search: search,
    };

    try {
      const response = await getSpotRegistrationData(payload);
      setData(response.data || []);

      // Check if response.pagination exists
      if (response.pagination) {
        setPagination(response.pagination);
      } else {
        // If pagination info not provided by API, derive from response
        setPagination((prev) => ({
          ...prev,
          totalRecords: response.data?.length || 0,
          totalPages: 1, // Or calculate manually if backend doesn't support pagination
        }));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // Trigger fetch data on page change, page size change, or search change
  useEffect(() => {
    fetchData();
  }, [pagination.currentPage, pagination.pageSize, search]);

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
    setPagination((prev) => ({ ...prev, currentPage: 1 }));
  };

  const handlePageSizeChange = (e) => {
    setPagination((prev) => ({
      ...prev,
      pageSize: parseInt(e.target.value),
      currentPage: 1,
    }));
  };

  const handlePageChange = (newPage) => {
    setPagination((prev) => ({ ...prev, currentPage: newPage }));
  };

  const handleBadgePrintCopy = async (item) => {
    try {
      // Show confirmation popup
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "Do you want to print this badge?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, Print it!",
        cancelButtonText: "Cancel",
      });

      if (result.isConfirmed) {
        // Navigate to Badge Print page only if confirmed
        navigate("/badge-print-card", {
          state: {
            id: item.id,
            name: item.name,
            company_name:
              item?.organization_name ||
              item?.deletegate_registation?.organization_name ||
              "-",
            qrUrl: item.url_for_qr,
          },
        });
      }
    } catch (error) {
      console.error("Error updating badge status:", error);
      Swal.fire(
        "Error!",
        "Something went wrong while updating badge status.",
        "error"
      );
    }
  };
  const handleLogout = () => {
    // Clear user session or authentication data
    sessionStorage.clear(); // or localStorage.clear();

    // Redirect to the homepage
    navigate("/admin/login");
  };

  return (
    <div id="page" className="page">
      <div className="inner-page-wrapper">
        <section className="division wide-30">
          <div className="container">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "10px 0",
              }}
            >
              <h2 style={{ margin: 0, fontSize: "24px", fontWeight: "bold" }}>
                EXPRESS ENTRY
              </h2>
              <div>
                <button
                  style={{
                    background: "#44929f",
                    padding: "6px 20px",
                    borderRadius: "40px",
                    fontSize: "16px",
                    fontWeight: 600,
                    color: "#fff",
                    marginRight: "10px",
                    border: "none",
                    cursor: "pointer",
                  }}
                  onClick={() => navigate("/spot-registration")}
                >
                  Register
                </button>
                <button
                  style={{
                    background: "#44929f",
                    padding: "6px 20px",
                    borderRadius: "40px",
                    fontSize: "16px",
                    fontWeight: 600,
                    color: "#fff",
                    border: "none",
                    cursor: "pointer",
                  }}
                  onClick={handleLogout}
                >
                  Logout
                </button>
              </div>
            </div>

            <div className="d-flex flex-wrap justify-content-center mt-4 mb-3 gap-3">
              {tabs.map((tab) => (
                <NavLink
                  key={tab.path}
                  to={tab.path}
                  className="fw-semibold text-decoration-none"
                  style={{
                    fontSize: "16px",
                    paddingBottom: "6px",
                    color: location.pathname === tab.path ? "#000" : "#000",
                    borderBottom:
                      location.pathname === tab.path ? "3px solid" : "none",
                  }}
                >
                  {tab.label}
                </NavLink>
              ))}
            </div>

            <div className="card">
              <div className="card-body">
                <div className="row">
                  <div className="col-md-12">
                    <h4 style={{ fontWeight: 700 }} className="font-bold">
                      Registration Request
                    </h4>
                    {/* Entries and Search UI */}
                    <div className="d-flex flex-column p- flex-lg-row justify-content-between align-items-start align-items-lg-center mb-3 mt-3 gap-3">
                      <div>
                        Show{" "}
                        <select
                          className="form-select d-inline-block w-auto border"
                          value={pagination.pageSize}
                          onChange={handlePageSizeChange}
                        >
                          <option value="10">10</option>
                          <option value="25">25</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                          <option value="500">500</option>
                        </select>{" "}
                      </div>
                      <div className={` ${!isMobile ? "w-80" : "w-100"}`}>
                        <input
                          type="search"
                          className="form-control"
                          placeholder="Search..."
                          value={search}
                          onChange={handleSearchChange}
                        />
                      </div>
                    </div>

                    {/* Table */}
                    <div className="table-responsive">
                      <table
                        id="request-list"
                        className="table table-bordered"
                        style={{ width: "100%" }}
                        data-order='[[0,"desc"]]'
                      >
                        <thead>
                          <tr className="text-center">
                            <th>Batch NO.</th>
                            <th>Name</th>
                            <th>Mobile</th>
                            <th>Company</th>
                            <th>Category</th>

                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {data.map((item) => (
                            <tr key={item.id}>
                              <td>{item.id}</td>
                              <td>{item.name}</td>
                              <td>{item.mobile}</td>
                              <td>
                                {" "}
                                <td>
                                  {item?.organization_name ||
                                    item?.deletegate_registation
                                      ?.organization_name ||
                                    "-"}
                                </td>
                              </td>
                              <td>
                                {item.deletegate_registation
                                  ?.deletegate_category || "-"}
                              </td>

                              <td className="text-center">
                                <button
                                  type="button"
                                  className="btn bg-primary btn-labeled rounded-pill link-white"
                                  style={{ color: "black" }}
                                  onClick={() => handleBadgePrintCopy(item)}
                                >
                                  Badge Print Copy
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>

                    {/* Pagination */}
                    <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mt-5">
                      <div className="mb-3 mb-md-0">
                        Showing{" "}
                        {(pagination.currentPage - 1) * pagination.pageSize + 1}{" "}
                        to{" "}
                        {Math.min(
                          pagination.currentPage * pagination.pageSize,
                          pagination.totalRecords
                        )}{" "}
                        of {pagination.totalRecords} entries
                      </div>

                      <nav>
                        <ul className="pagination mb-0 flex-wrap">
                          {/* Previous button */}
                          <li
                            className={`page-item ${
                              pagination.currentPage === 1 ? "disabled" : ""
                            }`}
                          >
                            <button
                              className="page-link"
                              onClick={() =>
                                handlePageChange(pagination.currentPage - 1)
                              }
                              disabled={pagination.currentPage === 1}
                            >
                              Previous
                            </button>
                          </li>

                          {/* Page numbers with ellipsis */}
                          {Array.from(
                            { length: pagination.totalPages },
                            (_, i) => i + 1
                          )
                            .filter(
                              (page) =>
                                page === 1 ||
                                page === pagination.totalPages ||
                                (page >= pagination.currentPage - 2 &&
                                  page <= pagination.currentPage + 2)
                            )
                            .map((page, idx, arr) => {
                              const prevPage = arr[idx - 1];
                              const showEllipsis =
                                prevPage && page - prevPage > 1;
                              return (
                                <React.Fragment key={page}>
                                  {showEllipsis && (
                                    <li className="page-item disabled">
                                      <span className="page-link">…</span>
                                    </li>
                                  )}
                                  <li
                                    className={`page-item ${
                                      pagination.currentPage === page
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    <button
                                      className="page-link"
                                      onClick={() => handlePageChange(page)}
                                    >
                                      {page}
                                    </button>
                                  </li>
                                </React.Fragment>
                              );
                            })}

                          {/* Next button */}
                          <li
                            className={`page-item ${
                              pagination.currentPage === pagination.totalPages
                                ? "disabled"
                                : ""
                            }`}
                          >
                            <button
                              className="page-link"
                              onClick={() =>
                                handlePageChange(pagination.currentPage + 1)
                              }
                              disabled={
                                pagination.currentPage === pagination.totalPages
                              }
                            >
                              Next
                            </button>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default BadgeAssigned;
